// Do not insert custom values to the colors or breakpoints Vuestic UI config
// or they will be overwritten! Use Tailwind CSS config instead.

import { createIconsConfig } from 'vuestic-ui'

const iconsConfig = createIconsConfig({
	aliases: [
		{ name: 'va-arrow-down', to: 'expand_more' },
		{ name: 'va-arrow-first', to: 'first_page' },
		{ name: 'va-arrow-last', to: 'last_page' },
		{ name: 'va-arrow-left', to: 'chevron_left' },
		{ name: 'va-arrow-right', to: 'chevron_right' },
		{ name: 'va-arrow-up', to: 'expand_less' },
		{ name: 'va-calendar', to: 'calendar_today' },
		{ name: 'va-check', to: 'check' },
		{ name: 'va-clear', to: 'cancel' },
		{ name: 'va-close', to: 'close' },
		{ name: 'va-delete', to: 'delete' },
		{ name: 'va-loading', to: 'sync' },
		{ name: 'va-warning', to: 'warning' },
	],
	fonts: [
		{
			name: '{icon}',
			resolve: ({ icon }) => ({ class: `material-symbols-outlined`, content: icon }),
		},
	],
})

export default {
	breakpoints: {
		thresholds: {
			xs: 320,
			sm: 480,
			md: 800,
			lg: 1024,
		},
	},
	colors: {
		variables: {
			black: '#000',
			white: '#fff',
			primary: '#9627b8',
			danger: '#ff0000',
			success :'#00ff00',
			backgroundPrimary: '#252525',
			backgroundSecondary: '#333333',
			textPrimary: '#001b40',

			'purple-50': '#faf6fc',
			'purple-100': '#f3ebf9',
			'purple-200': '#e8d7f3',
			'purple-300': '#d7b8ea',
			'purple-400': '#cb68e4',  // Your lighter primary color
			'purple-500': '#b13dd1',
			'purple-600': '#9627b8',
			'purple-700': '#782aa9',  // Your darker primary color
			'purple-800': '#5e2186',
			'purple-900': '#4d1b6d',
			'purple-950': '#2f0f45',
			'neutral-100': '#f6f6f6',
			'neutral-350': '#b1b1b1',
			'neutral-400': '#a3a3a3',
			'neutral-500': '#797979',
			'neutral-700': '#333333',
		},
		threshold: 170,
	},
	components: {
	},
	fontFamily: {
		sans: ['Varela Round', 'sans-serif'],
	},
	fontSize: {
		'2xs': ['10px', { lineHeight: '12px'}],
		xs: ['12px', { lineHeight: '14px'}],
		sm: ['14px', { lineHeight: '18px'}],
		md: ['16px', { lineHeight: '18px'}],
		lg: ['18px', { lineHeight: '24px'}],
		xl: ['24px', { lineHeight: '30px'}],
		'2xl': ['28px', { lineHeight: '36px'}],
		'3xl': ['36px', { lineHeight: '44px'}],
	},
	icons: iconsConfig,
}
